import { FIND_SERVICE_HISTORY_FORM_STATE_FIELD } from './constants'

export const getInitialValues = ({ statesOptions: [{ value }] = [{}]}) => ({
  [FIND_SERVICE_HISTORY_FORM_STATE_FIELD]: value
})
